//#region Imports
import React, { useState, useEffect, Fragment } from "react";
import sharedDatas from "../../businessLogic/sharedDatas";
import { useNavigate } from "react-router-dom";

//oneFront SDK
import {
  useSnackbar,
  useQuery,
  useMutation,
  useTranslation,
} from "@1f/react-sdk";

import VaporPage from "@vapor/react-custom/VaporPage";
import VaporToolbar from "@vapor/react-custom/VaporToolbar";

//Vapor Components
import Stack from "@vapor/react-material/Stack";
import Divider from "@vapor/react-material/Divider";
import Tooltip from "@vapor/react-material/Tooltip";
import CircularProgress from "@vapor/react-material/CircularProgress";


//Custom styles
import { divGreen, divRed, divYellow } from "../../businessLogic/styles";


//Custom components
import { Loading } from "../../components/Loading";
import { NotAuth } from "../../components/NotAuth";

//Constants, Api and Data Models
import { getLocalStorageImportType } from "../../businessLogic/helpers/storageHelpers";
import { bsaAnagrafica, bsaFascicolo } from "../../businessLogic/constants/securityAreas";
import {
  TIPO_PARTECIPAZIONE_ALTRO_KEY,
  TIPO_ANAGRAFICA_LEGALE_RAPP_KEY,
  TIPO_ANAGRAFICA_PROCURATORE_KEY,
  TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY,
} from "../../businessLogic/constants/baseTableKeys";
import {
  userPermissionModel,
  fascicoloModel,
  baseTipoPrestazioneModel,
  anagraficaModel,
} from "../../businessLogic/models";

import {
  query_base_tipo_anagrafica_byKey,
  query_base_paese_byIdent,
  query_base_paese_byNome,
  query_base_genere,
  query_base_all,
  query_base_tipo_prestazione_all,
} from "../../businessLogic/query/baseTablesQueries";

import {
  query_anagrafiche_byCf,
  query_anagrafiche_byCf_PG,
} from "../../businessLogic/query/anagraficaQueries";

import {
  query_importMapping_byTenant,
} from "../../businessLogic/query/importMappingQueries";

import {
  query_fascicolo_byTenant_byCustomer,
} from "../../businessLogic/query/fascicoloQueris";

import { mutation_add_audit } from "../../businessLogic/mutations/auditMutations";
import {
  mutation_add_import_mapping,
  mutation_update_import_mapping,
} from "../../businessLogic/mutations/importMappingMutations";
import { mutation_add_prestazione } from "../../businessLogic/mutations/prestazioneMutations";
import { mutation_add_prestazione_users } from "../../businessLogic/mutations/prestazioneUsersMutations";
import {WorkspaceApi} from "../../businessLogic/api/workspaceApi";
import { AdeApi } from "../../businessLogic/api/AdeApi";
import { isAlphaNumeric } from "../../businessLogic/helpers/stringHelpers";
//Other components
import { AnagraficaApi, useAnagraficaSearchQuery } from "../../businessLogic/api/anagraficaApi";
import { DateHelpers } from "../../businessLogic/helpers/dateHelpers";
import { LogApi } from "../../businessLogic/api/logApi";
import { FascicoloApi } from "../../businessLogic/api/fascicoloApi";
import { createFascicoloModel } from "../../businessLogic/helpers/modelHelpers";
import { AnagraficaFascicoloApi } from "../../businessLogic/api/anagraficaFascicoloApi";
import { UserApi } from "../../businessLogic/api/userApi";
import { BaseTableApi } from "../../businessLogic/api/baseTableApi";
import {
  createImportMappingModel,
  upsertImportMapping,
  upsertProfPrestMapping,
} from "./importDesktop/utils/importMappingHelpers";
import {
  extractValuesArray
} from "./importDesktop/utils/rowHelpers";
import {
  parseTabFile,
  parseWindows1252TabFile,
} from "./importDesktop/utils/fileParsing";
import {
  buildUploadRowsData,
  isMultiRowPg,
} from "./importDesktop/utils/uploadRowsHelpers";
import {
  checkLegaleRappStatusForRows,
  collectSelectionMappings,
} from "./importDesktop/utils/selectionMappingHelpers";
import {
  orderSelectedRowsByImportPriority,
  splitSelectedRowsByType,
} from "./importDesktop/utils/importConfirmHelpers";
import {
  processPfRows,
  processPgRows,
} from "./importDesktop/utils/importConfirmProcessingHelpers";
import {
  buildImportDescription,
  getBaseIdByKey,
  normalizeForComparison,
  parseItalianDateToUtc,
  resolveGenereIdByValue,
  resolveIdentDocTipoFallback,
  resolveMappedIntValue,
  resolveMappedProvinciaComune,
  resolvePaeseIdFromProvincia,
  splitNomeCognomeFromDenominazione,
} from "./importDesktop/utils/creationFlowHelpers";
import {
  fascicoliGridColumns,
  getAnagraficheGridColumns,
} from "./importDesktop/constants/gridColumns";
import { ImportUploadPanel } from "./importDesktop/components/ImportUploadPanel";
import { ImportFinishedPanel } from "./importDesktop/components/ImportFinishedPanel";
import { ImportToolbarActions } from "./importDesktop/components/ImportToolbarActions";
import { ImportSelectionPanel } from "./importDesktop/components/ImportSelectionPanel";
import { ImportAssociationPanel } from "./importDesktop/components/ImportAssociationPanel";
//#endregion

export const AnagraficaImportDesktop = ({ basePath }) => {

  const tenantId = sharedDatas.getPropertyByName("tenantId");
  const aziendaId = sharedDatas.getPropertyByName("aziendaId");
  const loggedUserId = sharedDatas.getPropertyByName("userId");
  var tenantTypeId = sharedDatas.getPropertyByName("userModel").tenantTipoId;
  const environment = sharedDatas.getPropertyByName("environment");
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  //#region Api
  const workspaceApi = WorkspaceApi();
  const anagraficaApi = AnagraficaApi();
  const adeApi = AdeApi();
  const fascicoloApi = FascicoloApi();
  const anagFascicoloApi = AnagraficaFascicoloApi();
  const userApi = UserApi()
  const dateHelpers = DateHelpers();
  const logApi = LogApi(); 
  //#endregion

  //#region Helpers
  const baseTablehelpers = BaseTableApi();

  //#region Query
  const apiBaseAll = useQuery(
    query_base_all,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiTipoAnagraficaByKey = useQuery(
    query_base_tipo_anagrafica_byKey,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiPaeseByIdent = useQuery(
    query_base_paese_byIdent,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiBaseGenere = useQuery(
    query_base_genere,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiBasePaeseByNome = useQuery(
    query_base_paese_byNome,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiAnagByCf = useAnagraficaSearchQuery(query_anagrafiche_byCf);
  const apiAnagByCfPG = useAnagraficaSearchQuery(query_anagrafiche_byCf_PG);
  const apiMappedValuesByTenantId = useQuery(
    query_importMapping_byTenant,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiFascicoliByTenantIdByCustomer = useQuery(
    query_fascicolo_byTenant_byCustomer,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  const apiBaseTipoPrestazione = useQuery(
    query_base_tipo_prestazione_all,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );
  //#endregion

  //#region Mutation
  const apiAddAudit = useMutation(mutation_add_audit, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  const apiAddMapping = useMutation(mutation_add_import_mapping, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  const apiUpdateMapping = useMutation(mutation_update_import_mapping, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  const apiAddPrestazione = useMutation(mutation_add_prestazione, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  const apiAddPrestazioneUsers = useMutation(mutation_add_prestazione_users, {
    graphqlEndpoint: "aml:hasura:api://v1/graphql",
  });
  //#endregion

  //#region UseState
  const [backDropOpen, setBackDropOpen] = useState(true); //Loader utilizzato durante il caricamento
  const [isDataLoaded, setIsDataLoaded] = useState(false); //Indica lo stato di caricamento del result Api
  const [userPermissions, setUserPermissions] = useState(
    new userPermissionModel(
      0,
      aziendaId,
      bsaAnagrafica,
      false,
      false,
      false,
      false
    )
  ); //Contiene i permessi utente

  //DataGrid  
  const [dataColumns, setDataColumns] = useState([]); //Contiene le columns
  const [dataRows, setDataRows] = useState([]); //Contiene le rows

  const [, setDataItems2] = useState([]); //Contiene i records
  const [dataColumns2, setDataColumns2] = useState([]); //Contiene le columns della DataGrid
  const [dataRows2, setDataRows2] = useState([]); //Contiene le rows della DataGrid
  // const [customRowItems2, setCustomRowItems2] = useState([]);
  // const [actionsRowItems2, setActionsRowItems2] = useState([]);
  const [mappedValuesList, setMappedValuesList] = useState([]);
  const [mappedProfPrestList, setMappedProfPrestList] = useState([]);
  const [mappedProfList,setMappedProfList] = useState([]);
  const [useImportDate, setUseImportDate] = useState(true);
  const [utentiList, setUtentiList] = useState([]);
  const [baseTipoIdentList, setBaseTipoIdentList] = useState([]);
  const [baseTipoDocList, setBaseTipoDocList] = useState([]);
  const [baseTipoPartList, setBaseTipoPartList] = useState([]);
  const [baseProvinceList, setBaseProvinceList] = useState([]);
  const [baseComuniList, setBaseComuniList] = useState([]);
  const [,setBasePaeseList] = useState([]);
  const [baseTipoPrestazioneList, setBaseTipoPrestazioneList] = useState([]);
  const [baseScopoPrestazioneList, setBaseScopoPrestazioneList] = useState([]);
  const [baseNaturaPrestazioneList, setBaseNaturaPrestazioneList] = useState(
    []
  );
  const [fascicoliCustomerList, setFascicoliCustomerList] = useState([]);
  const [importFinished, setImportFinished] = useState(false);
  const [importFinishedCountOk, setImportFinishedCountOk] = useState(0);
  const [importFinishedErrors, setImportFinishedErrors] = useState([]);
  const [selImportType, setSelImportType] = useState("");
  const [selectedProfId, setSelectedProfId] = useState("")
  //#endregion 

  useEffect(() => {
    loadDatas();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDataLoaded]);

  async function loadDatas() {
    try {
      if (
        sharedDatas.getPropertyByName("tenantId") === "" ||
        sharedDatas.getPropertyByName("tenantModel") === null ||
        sharedDatas.getPropertyByName("aziendaId") === 0 ||
        sharedDatas.getPropertyByName("aziendaModelList") === null ||
        sharedDatas.getPropertyByName("userId") === "" ||
        sharedDatas.getPropertyByName("userModel") === null
      ) {
        navigate("/");
      } else {
        setBackDropOpen(true);

        if (!isDataLoaded) {
          /**************************************/
          //Carico i permessi relativi all'utente
          setUserPermissions(
            sharedDatas
              .getPropertyByName("userPermissions")
              .filter((x) => x.area === bsaAnagrafica)[0]
          );

          /**************************************/
          //Carico gli utenti
          const usersResponse = await userApi.GetUsersByCompanyId();                            
          setUtentiList(usersResponse);

          /**************************************/
          //Carico le tabelle di base
          const apiBaseAllResponse = await apiBaseAll.fetch({
            tenantId: tenantId,
          });          
          let arrTipoIdenItems = baseTablehelpers.GetBaseTipoIdent(apiBaseAllResponse);         
          setBaseTipoIdentList(arrTipoIdenItems);

          const arrTipoDocItems = baseTablehelpers.GetBaseTipoDocumento(apiBaseAllResponse);          
          setBaseTipoDocList(arrTipoDocItems);

          const arrTipoPartItems = baseTablehelpers.GetBaseTipoPartecipazione(apiBaseAllResponse);
          setBaseTipoPartList(arrTipoPartItems);                

          const arrProvinceItems = baseTablehelpers.GetBaseProvincia(apiBaseAllResponse);          
          setBaseProvinceList(arrProvinceItems);

          const arrComuniItems = baseTablehelpers.GetBaseComune(apiBaseAllResponse);
          setBaseComuniList(arrComuniItems);                
          
          const arrItemPaesi = baseTablehelpers.GetBasePaese(apiBaseAllResponse);          
          setBasePaeseList(arrItemPaesi);                

          const scopoPresItems = baseTablehelpers.GetBaseScopoPrestazione(apiBaseAllResponse);          
          setBaseScopoPrestazioneList(scopoPresItems);

          const naturaPrestItems = baseTablehelpers.GetBaseNaturaPrestazione(apiBaseAllResponse);
          setBaseNaturaPrestazioneList(naturaPrestItems);

          const tipoPrestResponse = await apiBaseTipoPrestazione.fetch();
          const tipoPrestItems = [];
          for (
            let i = 0;
            i < tipoPrestResponse.data.data.base_tipo_prestazione.length;
            i++
          ) {
            const item = tipoPrestResponse.data.data.base_tipo_prestazione[i];
            let prefixPrest = "";
            if (item.BaseTenantTipoId === 1) {
              prefixPrest = "COMM";
            } else if (item.BaseTenantTipoId === 2) {
              prefixPrest = "CONS";
            } else if (item.BaseTenantTipoId === 3) {
              prefixPrest = "AVV";
            } else if (item.BaseTenantTipoId === 4) {
              prefixPrest = "NOT";
            }

            if(item.BaseTenantTipoId === tenantTypeId){
              tipoPrestItems.push(
                new baseTipoPrestazioneModel(
                  item.Id,
                  prefixPrest + " - " + item.Nome,
                  item.Rischio,
                  item.Regole
                )
              );
            }
          }
          setBaseTipoPrestazioneList(tipoPrestItems);                                                        

          //Carico i fascicoli per effettuarne il check successivamente
          const arrFascicoli = [];
          const fascResponse = await apiFascicoliByTenantIdByCustomer.fetch({
            tenantId: tenantId,
            aziendaId: aziendaId,
          });
          for (let i = 0; i < fascResponse.data.data.fascicolo.length; i++) {
            const item = fascResponse.data.data.fascicolo[i];

            // Itero su TUTTE le anagrafiche collegate al fascicolo
            // (clienti, legali rappresentanti, titolari effettivi, ecc.)
            for (let j = 0; j < item.anagrafica_fascicolos.length; j++) {
              const anagFasc = item.anagrafica_fascicolos[j];
              
              // Aggiungo solo se non è già presente (evito duplicati)
              const alreadyExists = arrFascicoli.some(
                x => x.fascicoloId === item.Id && 
                  x.cf === anagFasc.anagrafica.Cf && 
                  x.pIva === anagFasc.anagrafica.PIva
              );
              
              if (!alreadyExists) {
                arrFascicoli.push({
                  fascicoloId: item.Id,
                  fascicoloDenominazione: item.Name,
                  isPg: anagFasc.anagrafica.IsPg,
                  cf: anagFasc.anagrafica.Cf,
                  pIva: anagFasc.anagrafica.PIva,
                  denominazione: anagFasc.anagrafica.Denominazione,
                  tipoAnagrafica: anagFasc.base_tipo_anagrafica?.Key || ''
                });
              }
            }
          }
          setFascicoliCustomerList(arrFascicoli);

          /**************************************/
          //Carico i valori mappati
          const arrMappedValuesItems = [];
          const apiMappedValuesByTenantIdResponse =
            await apiMappedValuesByTenantId.fetch({
              tenantId: tenantId,
              aziendaId: aziendaId,
            });
          apiMappedValuesByTenantIdResponse.data.data.import_mapping.map(
            (item) =>
              arrMappedValuesItems.push(createImportMappingModel(item))
          );
          setMappedValuesList(arrMappedValuesItems);
          setMappedProfList(arrMappedValuesItems);
          
          if(arrMappedValuesItems.length > 0){
            let identProfId = arrMappedValuesItems.filter(x=>x.mappedValue === "Professionista che identifica")[0]?.value ?? ""
            setSelectedProfId(identProfId)
          }

          /**************************************/
          //Carico il tipo di import selezionato
          const selectedImportTypeResponse = getLocalStorageImportType();
          const selectedImportType = selectedImportTypeResponse;
          setSelImportType(selectedImportType);
        }
      }
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "loadDatas","AnagraficaImportDesktop");      
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    } finally {
      setBackDropOpen(false);
      setIsDataLoaded(true);
    }
  }
  
  //Import da Antiriciclaggio Desktop
  const [parsedFile, setParsedFile] = useState("");
  const [, setParsedData] = useState([]);
  const [parsedValues, setParsedValues] = useState([]);

  const [parsedArrProfList, setParsedArrProfList] = useState([]);
  const [parsedArrTipoIdentList, setParsedArrTipoIdentList] = useState([]);
  const [parsedArrTipoDocList, setParsedArrTipoDocList] = useState([]);
  const [parsedArrProvinceList, setParsedArrProvinceList] = useState([]);
  const [parsedArrComuniList, setParsedArrComuniList] = useState([]); 

  //DataGrid
  const [selectedRows, setSelectedRows] = useState([]);

  const applyUploadGridData = ({ importableRows, existingFascicoliRows }) => {
    setDataColumns(
      getAnagraficheGridColumns({ renderIsPgCell, renderCompleteCell, renderLegaleRappStatusCell })
    );
    setDataRows(importableRows);

    setDataColumns2(fascicoliGridColumns);
    setDataItems2(existingFascicoliRows);
    setDataRows2(existingFascicoliRows);
  };

  //#region Handler
  const handleUploadFile = async (file) => {
    try {            
      setBackDropOpen(true);
      setParsedFile(file[0].name);

      const results = await parseWindows1252TabFile(file[0]);
      const parsedRows = extractValuesArray(results, true);

      setParsedData(results.data);
      setParsedValues(parsedRows);

      const { importableRows, existingFascicoliRows } = buildUploadRowsData({
        valuesArray: parsedRows,
        importType: "aricdesktop",
        isAlphaNumericFn: isAlphaNumeric,
        fascicoliCustomerList,
      });

      const enrichedRows = await checkLegaleRappStatusForRows({
        importableRows,
        parsedValues: parsedRows,
        importType: "aricdesktop",
        fetchAnagByCf: apiAnagByCf.fetch,
        tenantId,
        isAlphaNumericFn: isAlphaNumeric,
      });

      applyUploadGridData({ importableRows: enrichedRows, existingFascicoliRows });
      setBackDropOpen(false);
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "handleUploadFile","AnagraficaImportDesktop");           
      enqueueSnackbar(t("error.generale"), { variant: "error" });
      setBackDropOpen(false);
    }
  };
  const handleUploadFileMulti = async (file) => {
    try {      
      setBackDropOpen(true);

      setParsedFile(file[0].name);

      const results = await parseTabFile(file[0]);
      const parsedRows = extractValuesArray(results);

      setParsedData(results.data);
      setParsedValues(parsedRows);

      const { importableRows, existingFascicoliRows } = buildUploadRowsData({
        valuesArray: parsedRows,
        importType: "multi",
        isAlphaNumericFn: isAlphaNumeric,
        fascicoliCustomerList,
      });

      const enrichedRows = await checkLegaleRappStatusForRows({
        importableRows,
        parsedValues: parsedRows,
        importType: "multi",
        fetchAnagByCf: apiAnagByCf.fetch,
        tenantId,
        isAlphaNumericFn: isAlphaNumeric,
      });

      applyUploadGridData({ importableRows: enrichedRows, existingFascicoliRows });
      setBackDropOpen(false);
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "handleUploadFileMulti","AnagraficaImportDesktop");        
      enqueueSnackbar(t("error.generale"), { variant: "error" });
      setBackDropOpen(false);
    }
  };
  const handleSelectedRow = async (row) => {
    try {
      setSelectedRows(row);

      // Mostra subito lo spinner su tutte le righe PG mentre il controllo è in corso
      setDataRows((prev) =>
        prev.map((r) =>
          r.isPg ? { ...r, legaleRappStatus: "loading" } : r
        )
      );

      const {
        arrProf,
        arrTipoIdent,
        arrTipoDoc,
        arrProvince,
        arrComuni,
      } = collectSelectionMappings({
        rowIds: row,
        parsedValues,
        selImportType,
        baseProvinceList,
        baseComuniList,
      });

      setParsedArrProfList(arrProf);
      setParsedArrTipoIdentList(arrTipoIdent);
      setParsedArrTipoDocList(arrTipoDoc);
      setParsedArrProvinceList(arrProvince);
      setParsedArrComuniList(arrComuni);

      // Ricalcola lo stato del legale rappresentante tenendo conto delle righe selezionate
      const enrichedRows = await checkLegaleRappStatusForRows({
        importableRows: dataRows,
        parsedValues,
        importType: selImportType,
        fetchAnagByCf: apiAnagByCf.fetch,
        tenantId,
        isAlphaNumericFn: isAlphaNumeric,
        selectedRowIds: row,
      });
      setDataRows(enrichedRows);
    } catch (e) {
      logApi.AddLog(e?.message || String(e), e?.stack || "", "handleSelectedRow","AnagraficaImportDesktop");        
      enqueueSnackbar(t("error.generale"), { variant: "error" });
    }
  };
  const handleChange = async (event, value, mappedValue) => {
    const { id } = event.target;
    if (!value) {
      return;
    }

    let mappedValuesListArr = [...mappedValuesList];

    if (id.indexOf("ddlProf-option") !== -1) {
      mappedValuesListArr = await upsertImportMapping({
        mappedValuesList: mappedValuesListArr,
        type: "professionista",
        mappedValue,
        value: value.userId,
        tenantId,
        aziendaId,
        apiAddMapping,
        apiUpdateMapping,
      });
      setSelectedProfId(value.userId);
      setMappedProfList(mappedValuesListArr);
    } else if (id.indexOf("ddlPrest-option") !== -1) {
      const mappedProfPrestListArr = upsertProfPrestMapping({
        mappedProfPrestList,
        cf: mappedValue,
        prestId: value.id,
      });

      setMappedProfPrestList(mappedProfPrestListArr);
    } else if (id.indexOf("ddlProvince-option") !== -1) {
      mappedValuesListArr = await upsertImportMapping({
        mappedValuesList: mappedValuesListArr,
        type: "provincia",
        mappedValue,
        value: value.id.toString(),
        tenantId,
        aziendaId,
        apiAddMapping,
        apiUpdateMapping,
      });
    } else if (id.indexOf("ddlComuni-option") !== -1) {
      mappedValuesListArr = await upsertImportMapping({
        mappedValuesList: mappedValuesListArr,
        type: "comune",
        mappedValue,
        value: value.id.toString(),
        tenantId,
        aziendaId,
        apiAddMapping,
        apiUpdateMapping,
      });
    } else if (id.indexOf("ddlTipoIdent-option") !== -1) {
      mappedValuesListArr = await upsertImportMapping({
        mappedValuesList: mappedValuesListArr,
        type: "tipoIdent",
        mappedValue,
        value: value.id.toString(),
        tenantId,
        aziendaId,
        apiAddMapping,
        apiUpdateMapping,
      });
    } else if (id.indexOf("ddlModIdentDoc-option") !== -1) {
      mappedValuesListArr = await upsertImportMapping({
        mappedValuesList: mappedValuesListArr,
        type: "tipoDoc",
        mappedValue,
        value: value.id.toString(),
        tenantId,
        aziendaId,
        apiAddMapping,
        apiUpdateMapping,
      });
    }

    setMappedValuesList(mappedValuesListArr);
  };
  const handleCancelClick = () => {
    setDataColumns([]);
    setDataRows([]);
  };
  const handleNewImportClick = () => {
    setImportFinished(false);
    setImportFinishedErrors([]);
    setImportFinishedCountOk(0);
    setDataColumns([]);
    setDataRows([]);
    setSelectedTab("tabImportabili");
    setIsDataLoaded(false);
  };
  const renderIsPgCell = (item) => {
    return item.row.isPg ? "Sì" : "No";
  };
  const renderLegaleRappStatusCell = (item) => {
    const { isPg, legaleRappStatus, legaleRappFascicolo } = item.row;

    if (!isPg || legaleRappStatus === null || legaleRappStatus === undefined) {
      return <span>-</span>;
    }

    if (legaleRappStatus === "loading") {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <CircularProgress size={14} thickness={5} />
          <span style={{ fontSize: "0.75rem", color: "#666" }}>Verifica...</span>
        </div>
      );
    }

    if (legaleRappStatus === "green") {
      return <div style={{ ...divGreen }}>Trovato</div>;
    }

    if (legaleRappStatus === "yellow") {
      return (
        <Tooltip
          title={<span>{`Il legale rappresentante collegato a questo fascicolo si trova nel fascicolo ${legaleRappFascicolo}, seleziona anche quella riga per importare correttamente questo record`}</span>}
          arrow
          placement="right"
        >
          <div style={{ ...divYellow }}>Nell&apos;import</div>
        </Tooltip>
      );
    }

    // red
    return <div style={{ ...divRed }}>Non trovato</div>;
  };
  const renderCompleteCell = (item) => {
    const status = item.row.isComplete;
    const statusReasons = item.row.isNotCompleteReason;
    let completeS = "No";

    switch (status) {
      case true: {
        completeS = "Sì";
        break;
      }
      case false: {
        completeS = "No";
        break;
      }
      default: {
        break;
      }
    }

    if (status) {
      return (
        <div style={{ ...(status === false ? divRed : divGreen) }}>
          {completeS}
        </div>
      );
    } else {
      return (
        <Tooltip
          title={
            <span style={{ whiteSpace: "pre-line" }}>{statusReasons}</span>
          }
          arrow
          placement="right"
        >
          <div style={{ ...(status === false ? divRed : divGreen) }}>
            {completeS}
          </div>
        </Tooltip>
      );
    }
  };
  const checkFormValues = () => {      
    if(mappedProfList.filter(x=> x.type === "professionista").length > 0){
      return true;
    }
    else{
      return false;
    }
  }

  const getImportConfirmProcessingContext = () => ({
    parsedValues,
    selImportType,
    isAlphaNumeric,
    tenantId,
    apiAnagByCf,
    apiAnagByCfPG,
    apiTipoAnagraficaByKey,
    anagFascicoloApi,
    createCliente,
    createClienteMulti,
    createFascicolo,
    createLegaleRapp,
    createLegaleRappMulti,
    createPrestazione,
    mappedValuesList,
    parsedArrProvinceList,
    parsedArrComuniList,
    baseProvinceList,
    baseComuniList,
    apiPaeseByIdent,
    apiBasePaeseByNome,
    fascicoliCustomerList,
    logApi,
    adeApi,
    environment,
    anagraficaApi,
  });

  const handleConfirmImportClick = async () => {  
    if(checkFormValues()){
      try {      
        setBackDropOpen(true);
        enqueueSnackbar(
          "L'operazione potrà richiedere qualche minuto, ti consigliamo di non chiudere il browser.",
          { variant: "warning" }
        );

        if (selectedRows.length > 0) {
          const importErrorsArr = [];
          const orderedSelectedRows = orderSelectedRowsByImportPriority({
            selectedRows,
            parsedValues,
            selImportType,
            isAlphaNumericFn: isAlphaNumeric,
          });

          // Per import MULTI o PAGHE: separare PG e PF
          let pgRows = [];
          let pfRows = [];
          let importedPGData = []; // Array per memorizzare i dati delle PG importate

          ({ pgRows, pfRows } = splitSelectedRowsByType({
            selectedRows: orderedSelectedRows,
            parsedValues,
            selImportType,
            isAlphaNumericFn: isAlphaNumeric,
          }));

          const importConfirmContext = getImportConfirmProcessingContext();

          await processPgRows({
            pgRows,
            importedPGData,
            importErrorsArr,
            context: importConfirmContext,
          });
          await processPfRows({
            pfRows,
            importedPGData,
            importErrorsArr,
            context: importConfirmContext,
          });

          setImportFinishedErrors(importErrorsArr);
          setImportFinishedCountOk(selectedRows.length - importErrorsArr.length);
          setSelectedRows([]);

          setParsedData([]);
          setParsedValues([]);
          setParsedArrProfList([]);
          setParsedArrTipoIdentList([]);
          setParsedArrTipoDocList([]);
          setParsedArrProvinceList([]);
          setParsedArrComuniList([]);
        }
      } catch (e) {
        logApi.AddLog(e.message, e.stack, "handleConfirmImportClick","AnagraficaImportDesktop");          
        enqueueSnackbar(t("error.generale"), { variant: "error" });
      } finally {
        setImportFinished(true);
        setBackDropOpen(false);
      }
    } else {
      enqueueSnackbar("Specificare un professionista per l'importazione", { variant: "error" });
    }
  };
  //#endregion

  //#region Creation Functions
  const createFascicolo = async (denominazione) => {
    try {
      var fascicolo = new fascicoloModel(
        0,
        tenantId,
        aziendaId,
        denominazione,
        new Date(),
        false,
        new Date(),
        null,
        [],
        "",
        "",
        loggedUserId
      );
      const fascicoloResp = await fascicoloApi.CreateFascicolo(tenantId,fascicolo);
      if (fascicoloResp) {
        const fascicoloResultModel = createFascicoloModel(fascicoloResp)
        //Aggiungo la Audit per tracciare l'azione
        const newValues = fascicoloResultModel;
        apiAddAudit.fetch({
          tenantId: tenantId,
          aziendaId: aziendaId,
          area: bsaFascicolo,
          operation: "Create",
          entityType: "fascicolo",
          entityId: fascicoloResultModel.id.toString(),
          oldValues: "",
          newValues: JSON.stringify(newValues),
        });

        return fascicoloResultModel;
      }
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "createFascicolo","AnagraficaImportDesktop");        
      return null;
    }
  };
  const createCliente = async (fascicolo, item) => {
  try {
    let cf = item[15].trimStart().trimEnd();
    let pIva = item[9].trimStart().trimEnd();
    let denominazione = item[1];
    const professione = item[2];

    // La ditta individuale (CF alfanumerico 16 car. + P.IVA) va importata come PG
    const isDI =
      cf !== "" &&
      pIva !== "" &&
      cf !== pIva &&
      cf.length === 16 &&
      isAlphaNumeric(cf);

    const isPg = isDI ? true : (item[3] === "S" ? false : true);

    if (isPg && cf === "") {
      cf = pIva;
    }

    const addrPaeseEstero = item[10];
    let addrComune = item[11];
    let addrProvincia = item[12];
    const addrIndirizzo = item[13];
    const addrCap = item[14];
    const nascitaData = item[16];
    const nascitaComune = item[17];
    const gender = item[19] === "1" ? "M" : "F";

    let identData = item[22];
    let identCfProf = selectedProfId;
    let identTipo = item[23];
    let identDocTipo = item[24];
    const identDocN = item[25];
    let identDocRilData = item[26];
    const identDocRilAutorita = item[27];

    const docDataScad = item[51];

    let searchAnagInDb = await anagraficaApi.GetAnagraficaFromDB(cf,pIva,isPg)
    if(searchAnagInDb.length === 1)
    {
      return searchAnagInDb[0];
    }

    if (identData !== "" && identDocRilData === "") {
      identDocRilData = identData;
    }

    /**************************************/
    //Recupero i valori mappati
    /**************************************/
    if (addrProvincia !== "EE") {
      addrProvincia = resolveMappedIntValue({
        mappedValuesList,
        type: "provincia",
        mappedValue: addrProvincia,
        parsedSourceValues: parsedArrProvinceList,
        fallback: () => {
          if (addrProvincia === null || addrProvincia === "") {
            return null;
          }

          const provinciaEntry = baseProvinceList.find(
            (item) => item?.sigla?.toLowerCase() === addrProvincia.toLowerCase()
          );
          return provinciaEntry?.id ? parseInt(provinciaEntry.id, 10) : null;
        },
      });

      addrComune = resolveMappedIntValue({
        mappedValuesList,
        type: "comune",
        mappedValue: addrComune,
        parsedSourceValues: parsedArrComuniList,
        fallback: () => {
          if (addrComune === null || addrComune === "") {
            return null;
          }

          const normalizedInput = normalizeForComparison(addrComune);
          const comuneEntry = baseComuniList.find(
            (item) => normalizeForComparison(item?.nome) === normalizedInput
          );
          return comuneEntry?.id ? parseInt(comuneEntry.id, 10) : null;
        },
      });
    }

    identTipo = resolveMappedIntValue({
      mappedValuesList,
      type: "tipoIdent",
      mappedValue: identTipo,
      parsedSourceValues: parsedArrTipoIdentList,
      fallback: () => getBaseIdByKey(baseTipoIdentList, "tipo_identificazione_1"),
    });

    identDocTipo = resolveMappedIntValue({
      mappedValuesList,
      type: "tipoDoc",
      mappedValue: identDocTipo,
      parsedSourceValues: parsedArrTipoDocList,
      fallback: () =>
        resolveIdentDocTipoFallback({
          baseTipoIdentList,
          baseTipoDocList,
          identTipo,
          isPg,
        }),
    });

    /**************************************/
    //Anagrafica
    /**************************************/      
    const paeseId = await resolvePaeseIdFromProvincia({
      provincia: addrProvincia,
      paeseEstero: addrPaeseEstero,
      fetchPaeseByIdent: apiPaeseByIdent.fetch,
      fetchPaeseByNome: apiBasePaeseByNome.fetch,
    });

    let nome = "";
    let cognome = "";
    let genereId = 0;

    if (!isPg) {
      genereId = await resolveGenereIdByValue({
        genderValue: gender,
        tenantId,
        fetchBaseGenere: apiBaseGenere.fetch,
      });

      // Usa la nuova funzione per determinare nome e cognome
      const nomeCognomeResult = splitNomeCognomeFromDenominazione({
        denominazione,
        cf,
        onError: (error) =>
          logApi.AddLog(
            `Errore nel parsing nome/cognome da CF: ${error.message}`,
            error.stack,
            "splitNomeCognomeFromDenominazione",
            "AnagraficaImportDesktop"
          ),
      });
      cognome = nomeCognomeResult.cognome;
      nome = nomeCognomeResult.nome;
    }
    
    const dataNascitaD = parseItalianDateToUtc(nascitaData, 12);
    const importDesc = buildImportDescription({
      parsedFile,
      parsedValuesLength: parsedValues.length,
    });
    
    //Creo il record di anagrafica      
    let dataIdentD = new Date();
    const parsedIdentDate = parseItalianDateToUtc(identData, 12);
    if (parsedIdentDate) {
      dataIdentD = parsedIdentDate;
      
      let anagrafica = new anagraficaModel(
        0,
        cf === "" ? pIva : cf,
        nome,
        cognome,
        nascitaComune,
        dateHelpers.FormatToUTCWithoutTimezone(dataNascitaD,false),
        professione,
        denominazione,
        pIva,
        "",
        "",
        "",
        "",
        addrIndirizzo,
        "",
        addrCap,
        null,
        null,
        "",
        "",
        "",
        false,
        false,
        new Date(),
        1,
        useImportDate ? dateHelpers.FormatDateToUTC(new Date(dataIdentD)) : dateHelpers.FormatDateToUTC(new Date()),
        0,
        isPg,
        paeseId,
        addrProvincia !== "EE" ? addrProvincia : null,
        addrComune !== "EE" ? addrComune : null,
        null,
        null,
        null,
        false,
        isPg ? null : genereId,
        "",
        loggedUserId,
        null,
        null,
        tenantId,
        importDesc,
        null,
        null,
        null,
        null,
        "",
        null,
        null,
        0,
        "",
        "",
        "",
        "",
        false,
        "",
        "IT",
        "",
        null,
        "",
        identTipo || 1,
        identDocTipo || null,
        identDocN,
        identDocRilAutorita,
        dateHelpers.FormatToUTCWithoutTimezone(identDocRilData,false) ?? "",
        docDataScad !== "" ? dateHelpers.FormatToUTCWithoutTimezone(docDataScad,false) : dateHelpers.FormatToUTCWithoutTimezone(new Date(),false),
        "",
        "",
        identCfProf,
        useImportDate ? dateHelpers.FormatToUTCWithoutTimezone(dataIdentD,false) : dateHelpers.FormatToUTCWithoutTimezone(new Date(),false),
        null,
        [],
        null,
        ""
      )
      let anagraficaPostResponse = await anagraficaApi.PostAnagrafica(anagrafica)

      if (anagraficaPostResponse) {
        try {
          await workspaceApi.UpdateItem(anagraficaPostResponse.id)
        } catch (e) {
          logApi.AddLog(`Error: ${e.message} trying to update on workspace anagrafica with Id ${anagraficaPostResponse.id}`, e.stack, "CreateClienteOnWorkspace", "AnagraficaImportDesktop")
        }
        return anagraficaPostResponse;
      }
    }
  } catch (e) {
    logApi.AddLog(e.message,e.stack,"createCliente","AnagraficaImportDesktop")        
    return null;
  }
};
  const createClienteMulti = async (fascicolo, item) => {
    try {      
      let cf = item[15].trimStart().trimEnd();
      let pIva = item[9].trimStart().trimEnd();
      let denominazione = item[1];
      const professione = item[2];      
      const isPg = isMultiRowPg(item, isAlphaNumeric);

      if (isPg && cf === "") {
        cf = pIva;
      }

      const addrPaeseEstero = item[10];
      let addrComune = item[11];
      let addrProvincia = item[12];
      const addrIndirizzo = item[13];
      const addrCap = item[14];
      const nascitaData = item[16];
      const nascitaComune = item[17];
      const gender = item[18] === "2" ? "F" : "M";

      /**************************************/
      //Recupero i valori mappati
      /**************************************/
      if (addrProvincia !== "EE") {
        addrProvincia = resolveMappedIntValue({
          mappedValuesList,
          type: "provincia",
          mappedValue: addrProvincia,
          parsedSourceValues: parsedArrProvinceList,
          fallback: () => {
            if (addrProvincia === null || addrProvincia === "") {
              return null;
            }

            const provinciaEntry = baseProvinceList.find(
              (item) => item?.sigla?.toLowerCase() === addrProvincia.toLowerCase()
            );
            return provinciaEntry?.id ? parseInt(provinciaEntry.id, 10) : null;
          },
        });

        addrComune = resolveMappedIntValue({
          mappedValuesList,
          type: "comune",
          mappedValue: addrComune,
          parsedSourceValues: parsedArrComuniList,
          fallback: () => {
            if (addrComune === null || addrComune === "") {
              return null;
            }

            const normalizedInput = normalizeForComparison(addrComune);
            const comuneEntry = baseComuniList.find(
              (item) => normalizeForComparison(item?.nome) === normalizedInput
            );
            return comuneEntry?.id ? parseInt(comuneEntry.id, 10) : null;
          },
        });
      }

      /**************************************/
      //Anagrafica
      /**************************************/
      const paeseId = await resolvePaeseIdFromProvincia({
        provincia: addrProvincia,
        paeseEstero: addrPaeseEstero,
        fetchPaeseByIdent: apiPaeseByIdent.fetch,
        fetchPaeseByNome: apiBasePaeseByNome.fetch,
      });

      let nome = "";
      let cognome = "";
      let genereId = 0;

      if (!isPg) {
        genereId = await resolveGenereIdByValue({
          genderValue: gender,
          tenantId,
          fetchBaseGenere: apiBaseGenere.fetch,
        });

        // Usa la nuova funzione per determinare nome e cognome
        const nomeCognomeResult = splitNomeCognomeFromDenominazione({
          denominazione,
          cf,
          onError: (error) =>
            logApi.AddLog(
              `Errore nel parsing nome/cognome da CF: ${error.message}`,
              error.stack,
              "splitNomeCognomeFromDenominazione",
              "AnagraficaImportDesktop"
            ),
        });
        cognome = nomeCognomeResult.cognome;
        nome = nomeCognomeResult.nome;
      }

      const dataNascitaD = parseItalianDateToUtc(nascitaData, 0);
      const importDesc = buildImportDescription({
        parsedFile,
        parsedValuesLength: parsedValues.length,
      });

      //Verifico l'esistenza del CF in qualità di Cliente
      let anagByCfResponse = null;
      if (!isPg) {
        anagByCfResponse = await apiAnagByCf.fetch({
          tenantId: tenantId,
          cf: "%" + cf + "%",
          nome: "%%",
          cognome: "%%",
        });
      } else {
        anagByCfResponse = await apiAnagByCfPG.fetch({
          tenantId: tenantId,
          cf: "%" + cf + "%",
          pIva: "%" + pIva + "%",
          denominazione: "%%",
        });
      }

      //Se esiste aggiungo solo la relazione tra anagrafica e fascicolo
      if (
        anagByCfResponse !== null &&
        anagByCfResponse.data.data.anagrafica.length > 0
      ) {
        return anagByCfResponse;
      }
      //altrimenti creo il record di anagrafica
      else {
        let anagrafica = new anagraficaModel(
          0,
          cf === "" ? pIva : cf,
          nome,
          cognome,
          nascitaComune,
          dateHelpers.FormatToUTCWithoutTimezone(dataNascitaD,false),
          professione,
          denominazione,
          pIva,
          "",
          "",
          "",
          "",
          addrIndirizzo,
          "",
          addrCap,
          null,
          null,
          "",
          "",
          "",
          false,
          false,
          new Date(),
          1,
          dateHelpers.FormatDateToUTC(new Date()),
          0,
          isPg,
          paeseId,
          addrProvincia !== "EE" ? addrProvincia : "",
          addrComune !== "EE" ? addrComune : "",
          null,
          null,
          null,
          false,
          isPg ? null : genereId,
          "",
          loggedUserId,
          null,
          null,
          tenantId,
          importDesc,
          null,
          null,
          null,
          null,
          "",
          null,
          null,
          0,
          "",
          "",
          "",
          "",
          false,
          "",
          "IT",
          "",
          null,
          "",
          1,
          isPg ? baseTipoDocList.filter((x) => x.key === "tipo_documento_3")[0]?.id : baseTipoDocList.filter((x) => x.key === "tipo_documento_1")[0]?.id,
          "",
          "",
          null,
          null,
          "",
          "",
          selectedProfId,
          null, 
          null,
          [],
          null,
          ""
        )              

        let anagraficaPostResponse = await anagraficaApi.PostAnagrafica(anagrafica)
        if (anagraficaPostResponse) {
          /**************************************/
          //Salvo le modifiche su Workspace
          /**************************************/
          try {
            await workspaceApi.UpdateItem(anagraficaPostResponse.id)
          } catch (e) {
            logApi.AddLog(`Error: ${e.message} trying to update on workspace anagrafica with Id ${anagraficaPostResponse.id}`, e.stack, "CreateClienteMultiOnWorkspace", "AnagraficaImportDesktop")
          }
          return anagraficaPostResponse;
        }                            
      }  
    } catch (e) {
      logApi.AddLog(e.message,e.stack,"createCliente","AnagraficaImportDesktop")  
      return null;
    }
  };
  const createLegaleRapp = async (fascicolo, item, options = {}) => {
    try {
      const { forceTitolareEffettivo = false } = options;
      const professione = forceTitolareEffettivo ? item[2] : item[30];
      const rappDenominazione = forceTitolareEffettivo ? item[1] : item[29];
      const rappNascitaComune = forceTitolareEffettivo ? item[17] : item[32];
      const rappNascitaData =  forceTitolareEffettivo ? item[16] : item[34];
      const rappGender = forceTitolareEffettivo ? (item[19] === "1" ? "M" : "F") : (item[35] === "1" ? "M" : "F");
      const rappAddrIndirizzo = forceTitolareEffettivo ? item[13] : item[36];
      const rappAddrCap = forceTitolareEffettivo ? item[14] : item[37];
      const rappAddrPaeseEstero = forceTitolareEffettivo ? item[10] : item[38];
      let rappAddrProvincia = forceTitolareEffettivo ? item[12] : item[40];
      let rappAddrComune = forceTitolareEffettivo ? item[11] : item[39];
      const rappCf = forceTitolareEffettivo ? item[15].trimStart().trimEnd() : item[41].trimStart().trimEnd();

      let identCfProf2 = selectedProfId
      let identData2 =  forceTitolareEffettivo ? item[22] : item[44];
      let identDocTipo2 = forceTitolareEffettivo ? item[24] : item[46];
      const identDocN2 = forceTitolareEffettivo ? item[25] : item[47];
      let identDocRilData2 = forceTitolareEffettivo ? item[26] : item[48];
      const identDocRilAutorita2 = forceTitolareEffettivo ? item[27] : item[49];

      const legame = forceTitolareEffettivo ? "00" : item[50]; //00 = Legale rappresentante (principale); 07 = Mandato con rappresentanza; 08 mandato senza rappresentanza; 09 = altro

      const docDataScadRapp = forceTitolareEffettivo ? item[51] : item[52];
      const isLegaleRappTitEff = item[53] === "S" ? true : false;

      if (identData2 !== "" && identDocRilData2 === "") {
        identDocRilData2 = identData2;
      }

      if (
        legame !== "" &&
        rappDenominazione !== "" &&        
        rappNascitaData !== "" &&
        rappGender !== "" &&        
        rappCf !== ""
      ) {
        const mappedAddress = resolveMappedProvinciaComune({
          provincia: rappAddrProvincia,
          comune: rappAddrComune,
          parsedArrProvinceList,
          parsedArrComuniList,
          mappedValuesList,
          baseProvinceList,
          baseComuniList,
        });
        rappAddrProvincia = mappedAddress.provincia;
        rappAddrComune = mappedAddress.comune;

        /**************************************/
        //Anagrafica
        /**************************************/
        const tipoAnagKey =
          legame === "00" ? TIPO_ANAGRAFICA_LEGALE_RAPP_KEY : TIPO_ANAGRAFICA_PROCURATORE_KEY;
        const tipoAnagByKeyResp = await apiTipoAnagraficaByKey.fetch({
          key: tipoAnagKey,
        });
        const tipoAnagId =
          tipoAnagByKeyResp.data.data.base_tipo_anagrafica.length > 0
            ? tipoAnagByKeyResp.data.data.base_tipo_anagrafica[0].Id
            : 0;

        const paeseId = await resolvePaeseIdFromProvincia({
          provincia: rappAddrProvincia,
          paeseEstero: rappAddrPaeseEstero,
          fetchPaeseByIdent: apiPaeseByIdent.fetch,
          fetchPaeseByNome: apiBasePaeseByNome.fetch,
        });

        let nome =
          rappDenominazione !== ""
            ? rappDenominazione.split(" ")[1]
            : rappDenominazione;
        let cognome =
          rappDenominazione !== ""
            ? rappDenominazione.split(" ")[0]
            : rappDenominazione;
        const genereId = await resolveGenereIdByValue({
          genderValue: rappGender,
          tenantId,
          fetchBaseGenere: apiBaseGenere.fetch,
        });
        const dataNascitaD = parseItalianDateToUtc(rappNascitaData, 1);

        let anagLegRapp = null;
        const anagLegRappResponse = await apiAnagByCf.fetch({
          tenantId: tenantId,
          cf: "%" + rappCf + "%",
          nome: "%%",
          cognome: "%%",
        });

        let isInFascicoloLegRapp = false;
        let isInFascicoloTitEff = false;

        if (
          anagLegRappResponse !== null &&
          anagLegRappResponse.data.data.anagrafica.length > 0
        ) {
          anagLegRapp = anagLegRappResponse.data.data.anagrafica[0];

          isInFascicoloLegRapp =
            anagLegRapp.anagrafica_fascicolos.length > 0 &&
            anagLegRapp.anagrafica_fascicolos.filter(
              (y) =>
                (y.FascicoloId === fascicolo.id &&
                  y.base_tipo_anagrafica.Key === TIPO_ANAGRAFICA_LEGALE_RAPP_KEY) ||
                (y.FascicoloId === fascicolo.id &&
                  y.base_tipo_anagrafica.Key === TIPO_ANAGRAFICA_PROCURATORE_KEY)
            ).length > 0;
          isInFascicoloTitEff =
            anagLegRapp.anagrafica_fascicolos.length > 0 &&
            anagLegRapp.anagrafica_fascicolos.filter(
              (y) =>
                y.FascicoloId === fascicolo.id &&
                y.base_tipo_anagrafica.Key === TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY
            ).length > 0;

          
          //Se l'anagrafica non è collegata al fascicolo
          if (!isInFascicoloLegRapp) {
            //Aggiungo la relazione tra anagrafica e fascicolo 
            await anagFascicoloApi.PostAnagraficaFascicolo(
              {
                anagraficaId: anagLegRapp.Id,
                fascicoloId: fascicolo.id,
                tipoAnagId: tipoAnagId
              },
              fascicolo.id
            )           
          }
          if(isLegaleRappTitEff || forceTitolareEffettivo){
            await anagFascicoloApi.PostAnagraficaFascicolo(
              {
                anagraficaId: anagLegRapp.Id,
                fascicoloId: fascicolo.id,
                tipoAnagId: 5
              },
              fascicolo.id
            ) 
          }
        } else {
          //Dati import
          const importDesc = buildImportDescription({
            parsedFile,
            parsedValuesLength: parsedValues.length,
          });

          let dataIdentD = new Date();
          const parsedIdentDate = parseItalianDateToUtc(identData2, 1);
          if (parsedIdentDate) {
            dataIdentD = parsedIdentDate;
          }
          let anagModel = new anagraficaModel(
            0,
            rappCf,
            nome,
            cognome,
            rappNascitaComune,
            dateHelpers.FormatToUTCWithoutTimezone(dataNascitaD,false) ?? null,
            professione,
            rappDenominazione,
            "",
            "",
            "",
            "",
            paeseId !== 89 ? rappAddrComune : "",
            rappAddrIndirizzo,
            "",
            rappAddrCap,
            null,
            null,
            "",
            "",
            "",
            false,
            false,
            new Date(),
            1,
            useImportDate ? dateHelpers.FormatDateToUTC(new Date(dataIdentD)) : dateHelpers.FormatDateToUTC(new Date()),
            0,
            false,
            paeseId,
            paeseId === 89 ? rappAddrProvincia : null,
            paeseId === 89 ? rappAddrComune : null,
            null,
            null,
            null,
            false,
            genereId,
            "",
            loggedUserId,
            null,
            null,
            tenantId,
            importDesc,
            null,
            null,
            null,
            null,
            "",
            null,
            null,
            0,
            "",
            "",
            "",
            "",
            false,
            "",
            "IT",
            "",
            null,
            "",
            1,
            identDocTipo2 !== "" ? baseTipoDocList.filter(x => x.id === +identDocTipo2)[0]?.id : baseTipoDocList.filter((x) => x.key === "tipo_documento_1")[0]?.id,
            identDocN2,
            identDocRilAutorita2,
            dateHelpers.FormatToUTCWithoutTimezone(identDocRilData2,false) ?? "",
            docDataScadRapp !== "" ? dateHelpers.FormatToUTCWithoutTimezone(docDataScadRapp,false) : dateHelpers.FormatToUTCWithoutTimezone(new Date(),false),
            "",
            "",
            identCfProf2,
            useImportDate ? dateHelpers.FormatToUTCWithoutTimezone(dataIdentD,false) : dateHelpers.FormatToUTCWithoutTimezone(new Date(),false),
            null,
            [],
            null,
            ""
          )
          let anagraficaPostRespose = await anagraficaApi.PostAnagrafica(anagModel)          
          if(anagraficaPostRespose){
            /**************************************/
            //Aggiungo la relazione tra anagrafica e fascicolo
            /**************************************/
            if (!isInFascicoloLegRapp) {
                await anagFascicoloApi.PostAnagraficaFascicolo(
                  {
                    anagraficaId: anagraficaPostRespose.id,
                    fascicoloId: fascicolo.id,
                    tipoAnagId: tipoAnagId
                  },
                  fascicolo.id
                ) 
            }
  
            /**************************************/
            //Salvo le modifiche su Workspace
            /**************************************/
            try {
              await workspaceApi.UpdateItem(anagraficaPostRespose.id)
            } catch (e) {
              logApi.AddLog(`Error: ${e?.message || String(e)} trying to update on workspace anagrafica with Id ${anagraficaPostRespose.id}`, e?.stack || "", "CreateLegaleRappOnWorkspace", "AnagraficaImportDesktop")
            }

          /**************************************/
          //Titolare Effettivo
          /**************************************/
          if (isLegaleRappTitEff || forceTitolareEffettivo) {
            const tipoAnagKey3 = TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY;
            const tipoAnagByKeyResp3 = await apiTipoAnagraficaByKey.fetch({
              key: tipoAnagKey3,
            });
            const tipoAnagId3 =
              tipoAnagByKeyResp3.data.data.base_tipo_anagrafica.length > 0
                ? tipoAnagByKeyResp3.data.data.base_tipo_anagrafica[0].Id
                : 0;
    
            const tipoPartItem = baseTipoPartList.filter(
              (x) => x.key === TIPO_PARTECIPAZIONE_ALTRO_KEY
            )[0];
            
            if (!tipoPartItem) {
              console.warn("Tipo partecipazione non trovato");
              return anagLegRapp;
            }
            
            const tipoPartId = tipoPartItem.id;
    
            //Se l'anagrafica non è collegata al fascicolo
            if (!isInFascicoloTitEff) {
              //Aggiungo la relazione tra anagrafica e fascicolo
              await anagFascicoloApi.PostAnagraficaFascicolo(
                {
                  anagraficaId: anagraficaPostRespose.id,
                  fascicoloId: fascicolo.id,
                  tipoAnagId: tipoAnagId3,
                  tipoPartId: tipoPartId,
                },
                fascicolo.id
              )
            }         
          }
  
          return anagLegRapp;
          }      
        }
      }
    } 
    catch (e) {
      logApi.AddLog(e?.message || String(e), e?.stack || "", "createLegalRapp", "AnagraficaImportDesktop")        
      return null;
    }
  };
  const createLegaleRappMulti = async (fascicolo, item, options = {}) => {
    try {
      const { forceTitolareEffettivo = false } = options;
      const rappAddrPaeseEstero = item[10].trimEnd().trimStart();
      let rappCognome, rappNome;
      if (forceTitolareEffettivo) {
        const nomeCognomeResult = splitNomeCognomeFromDenominazione({
          denominazione: item[1],
          cf: item[15].trimStart().trimEnd(),
          onError: (error) =>
            logApi.AddLog(
              `Errore nel parsing nome/cognome da CF: ${error.message}`,
              error.stack,
              "splitNomeCognomeFromDenominazione",
              "AnagraficaImportDesktop"
            ),
        });
        rappCognome = nomeCognomeResult.cognome;
        rappNome = nomeCognomeResult.nome;
      } else {
        rappCognome = item[19].trimEnd().trimStart();
        rappNome = item[20].trimEnd().trimStart();
      }
      const rappNascitaComune = forceTitolareEffettivo ? item[17].trimEnd().trimStart() : item[21].trimEnd().trimStart();
      const rappNascitaData = forceTitolareEffettivo ? item[16].trimEnd().trimStart() : item[23].trimEnd().trimStart();
      const rappGender = forceTitolareEffettivo ? (item[18] === "2" ? "F" : "M") : (item[24] === "2" ? "F" : "M");
      const rappAddrIndirizzo = forceTitolareEffettivo ? item[13].trimEnd().trimStart() : item[25].trimEnd().trimStart();
      let rappAddrComune = forceTitolareEffettivo ? item[11].trimEnd().trimStart() : item[26].trimEnd().trimStart();
      let rappAddrProvincia = forceTitolareEffettivo ? item[12].trimEnd().trimStart() : item[27].trimEnd().trimStart();
      let rappAddrCap = item[14].trimEnd().trimStart();
      const rappCf = forceTitolareEffettivo ? item[15].trimStart().trimEnd() : item[28].trimStart().trimEnd();

      const legame = "00"; //00 = Legale rappresentante (principale); 07 = Mandato con rappresentanza; 08 mandato senza rappresentanza; 09 = altro

      // Nota: l'indirizzo del legale rappresentante (indirizzo/comune/provincia)
      // non è obbligatorio sul POST anagrafica e in diversi tracciati "multi"
      // non è valorizzato. Richiediamo solo i dati identificativi/anagrafici
      // essenziali, in coerenza con lo stato "Trovato" e con la condizione che
      // innesca questa creazione (cognome/nome/comune nascita/CF).
      const passesGuard = forceTitolareEffettivo
        ? legame !== "" && rappCf !== ""
        : legame !== "" && rappCognome !== "" && rappNome !== "" &&
          rappNascitaComune !== "" && rappNascitaData !== "" && rappGender !== "" &&
          rappCf !== "";

      if (passesGuard) {
        const mappedAddress = resolveMappedProvinciaComune({
          provincia: rappAddrProvincia,
          comune: rappAddrComune,
          parsedArrProvinceList,
          parsedArrComuniList,
          mappedValuesList,
          baseProvinceList,
          baseComuniList,
        });
        rappAddrProvincia = mappedAddress.provincia;
        rappAddrComune = mappedAddress.comune;

        /**************************************/
        //Anagrafica
        /**************************************/
        const tipoAnagKey =
          legame === "00" ? TIPO_ANAGRAFICA_LEGALE_RAPP_KEY : TIPO_ANAGRAFICA_PROCURATORE_KEY;
        const tipoAnagByKeyResp = await apiTipoAnagraficaByKey.fetch({
          key: tipoAnagKey,
        });
        const tipoAnagId =
          tipoAnagByKeyResp.data.data.base_tipo_anagrafica.length > 0
            ? tipoAnagByKeyResp.data.data.base_tipo_anagrafica[0].Id
            : 0;

        const paeseId = await resolvePaeseIdFromProvincia({
          provincia: rappAddrProvincia,
          paeseEstero: rappAddrPaeseEstero,
          fetchPaeseByIdent: apiPaeseByIdent.fetch,
          fetchPaeseByNome: apiBasePaeseByNome.fetch,
        });

        const genereId = await resolveGenereIdByValue({
          genderValue: rappGender,
          tenantId,
          fetchBaseGenere: apiBaseGenere.fetch,
        });
        const dataNascitaD = parseItalianDateToUtc(rappNascitaData, 1);

        let anagLegRapp = null;
        const anagLegRappResponse = await apiAnagByCf.fetch({
          tenantId: tenantId,
          cf: "%" + rappCf + "%",
          nome: "%%",
          cognome: "%%",
        });

        let isInFascicoloLegRapp = false;
        let isInFascicoloTitEff = false;

        if (
          anagLegRappResponse !== null &&
          anagLegRappResponse.data.data.anagrafica.length > 0
        ) {
          anagLegRapp = anagLegRappResponse.data.data.anagrafica[0];

          isInFascicoloLegRapp =
            anagLegRapp.anagrafica_fascicolos.length > 0 &&
            anagLegRapp.anagrafica_fascicolos.filter(
              (y) =>
                (y.FascicoloId === fascicolo.id &&
                  y.base_tipo_anagrafica.Key === TIPO_ANAGRAFICA_LEGALE_RAPP_KEY) ||
                (y.FascicoloId === fascicolo.id &&
                  y.base_tipo_anagrafica.Key === TIPO_ANAGRAFICA_PROCURATORE_KEY)
            ).length > 0;

          isInFascicoloTitEff =
            anagLegRapp.anagrafica_fascicolos.length > 0 &&
            anagLegRapp.anagrafica_fascicolos.filter(
              (y) =>
                y.FascicoloId === fascicolo.id &&
                y.base_tipo_anagrafica.Key === TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY
            ).length > 0;

          //Se l'anagrafica non è collegata al fascicolo
          if (!isInFascicoloLegRapp) {
            //Aggiungo la relazione tra anagrafica e fascicolo
            await anagFascicoloApi.PostAnagraficaFascicolo(
              {
                anagraficaId: anagLegRapp.Id,
                fascicoloId: fascicolo.id,
                tipoAnagId: tipoAnagId,                
              },
              fascicolo.id
            )
          }

          if (forceTitolareEffettivo && !isInFascicoloTitEff) {
            await anagFascicoloApi.PostAnagraficaFascicolo(
              {
                anagraficaId: anagLegRapp.Id,
                fascicoloId: fascicolo.id,
                tipoAnagId: 5,
              },
              fascicolo.id
            )
          }
        } else {
          //Dati import
          const importDesc = buildImportDescription({
            parsedFile,
            parsedValuesLength: parsedValues.length,
          });

          let anagModel = new anagraficaModel(
            0,
            rappCf,            
            rappNome,
            rappCognome,
            rappNascitaComune,
            dateHelpers.FormatToUTCWithoutTimezone(dataNascitaD,false) ?? null,
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            rappAddrIndirizzo,
            "",
            rappAddrCap,
            null,
            null,
            "",
            "",
            "",
            false,
            false,
            new Date(),
            1,
            dateHelpers.FormatDateToUTC(new Date()),
            0,
            false,
            paeseId,
            rappAddrProvincia !== "EE" ? rappAddrProvincia : "",
            rappAddrComune !== "EE" ? rappAddrComune : "",
            null,
            null,
            null,
            false,
            genereId,
            "",
            loggedUserId,
            null,
            null,
            tenantId,
            importDesc,
            null,
            null,
            null,
            null,
            "",
            null,
            null,
            0,
            "",
            "",
            "",
            "",
            false,
            "",
            "IT",
            "",
            null,
            "",
            1,
            baseTipoDocList.filter((x) => x.key === "tipo_documento_1")[0]?.id,
            "",
            "",
            null,
            null,
            null,
            "",
            selectedProfId,
            null, 
            null,
            [],
            null,
            ""
          )          
          let anagraficaPostRespose = await anagraficaApi.PostAnagrafica(anagModel)
          if(anagraficaPostRespose){            
            /**************************************/
            //Aggiungo la relazione tra anagrafica e fascicolo
            /**************************************/
            if (!isInFascicoloLegRapp) {
              await anagFascicoloApi.PostAnagraficaFascicolo(
                {
                  anagraficaId: anagraficaPostRespose.id,
                  fascicoloId: fascicolo.id,
                  tipoAnagId: tipoAnagId,                
                },
                fascicolo.id
              )
            }

            if (forceTitolareEffettivo) {
              await anagFascicoloApi.PostAnagraficaFascicolo(
                {
                  anagraficaId: anagraficaPostRespose.id,
                  fascicoloId: fascicolo.id,
                  tipoAnagId: 5,
                },
                fascicolo.id
              )
            }
  
            /**************************************/
            //Salvo le modifiche su Workspace
            /**************************************/            
            try {
              await workspaceApi.UpdateItem(anagraficaPostRespose.id)
            } catch (e) {
              logApi.AddLog(`Error: ${e?.message || String(e)} trying to update on workspace anagrafica with Id ${anagraficaPostRespose.id}`, e?.stack || "", "CreateLegaleRappMultiOnWorkspace", "AnagraficaImportDesktop")
            }
            return anagLegRapp;
          }
        }
      } else {
        // Dati identificativi/anagrafici del legale rappresentante insufficienti:
        // non creiamo l'anagrafica ma segnaliamo l'esito invece di fallire in modo silenzioso.
        const missing = [
          rappCognome === "" ? "cognome" : null,
          rappNome === "" ? "nome" : null,
          rappNascitaComune === "" ? "comune di nascita" : null,
          rappNascitaData === "" ? "data di nascita" : null,
          rappCf === "" ? "codice fiscale" : null,
        ].filter(Boolean).join(", ");
        const reason = `Legale rappresentante non importato: dati insufficienti (${missing || "campi obbligatori mancanti"})`;
        logApi.AddLog(reason, "", "createLegalRappMulti", "AnagraficaImportDesktop");
        return { skipped: true, reason };
      }
    } catch (e) {
      logApi.AddLog(e?.message || String(e), e?.stack || "", "createLegalRappMulti", "AnagraficaImportDesktop");
      return null;
    }
  };
  const createPrestazione = async (
    fascicolo,
    identCfProf,
    data,
    paeseId,
    addrProvincia,
    addrComune
  ) => {
    try {
      const professionistaMappings = mappedValuesList.filter(
        (x) => x.type === "professionista" && x.value === identCfProf
      );

      if (professionistaMappings.length <= 0) {
        return;
      }

      const mappedPrestazione = mappedProfPrestList.find((prestazione) =>
        professionistaMappings.some(
          (mapping) => mapping.mappedValue === prestazione.cf
        )
      );

      if (!mappedPrestazione) {
        return;
      }

      const addPrestazioneResponse = await apiAddPrestazione.fetch({
        fascicoloId: fascicolo.id,
        tipoKey: "N",
        prestazioneId: mappedPrestazione.prestId,
        naturaId: baseNaturaPrestazioneList.filter(
          (x) => x.key === "base_natura_prestazione_3"
        )[0].id,
        scopoId: baseScopoPrestazioneList.filter(
          (x) => x.key === "base_scopo_prestazione_1"
        )[0].id,
        startDate: data !== null ? data : new Date(),
        endDate: null,
        paeseId: paeseId,
        provinciaId: addrProvincia !== "EE" ? addrProvincia : null,
        provincia: addrProvincia === "EE" ? addrProvincia : "",
        cittaId: addrProvincia !== "EE" ? addrComune : null,
        citta: addrProvincia === "EE" ? addrComune : "",
        descrizione: "",
        isPrivate: false,
        astensioneMotivo: "",
        isEsoneroObbAst: false,
        settoreAttivita: "",
        settorePrestazione: "",
        ragione: "",
      });

      if (addPrestazioneResponse.data.errors === undefined) {
        const insertedPrestazione = addPrestazioneResponse.data.data.insert_prestazione_one;

        await apiAddPrestazioneUsers.fetch({
          objects: [
            {
              PrestazioneId: insertedPrestazione.Id,
              UserId: identCfProf,
            },
          ],
        });
      }
    } catch (e) {
      logApi.AddLog(e.message, e.stack, "createPrestazione","AnagraficaImportDesktop");
      return null;
    }
  };
  //#endregion  

  //#region Tabs
  const [selectedTab, setSelectedTab] = useState("tabImportabili");
  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };
  //#endregion  

  //#region Return graphics
  return (
    <Fragment>
      <VaporPage
        title={
          selImportType === "aricdesktop"
            ? "Import da Antiriciclaggio Desktop"
            : "Import da TS Studio Contabilità, Paghe, Redditi e ViaLibera"
        }
      >
        <Loading open={backDropOpen} />

        {isDataLoaded && !userPermissions.canCreate ? <NotAuth /> : null}

        {isDataLoaded && userPermissions.canCreate ? (
          <VaporPage.Section>
            {!importFinished ? (
              <Fragment>
                <ImportUploadPanel
                  t={t}
                  importType={selImportType}
                  onUploadDesktopFile={handleUploadFile}
                  onUploadMultiFile={handleUploadFileMulti}
                />

                {dataRows.length > 0 || dataRows2.length > 0 ? (
                  <Fragment>
                    <Divider variant="standard" />
                    <Stack direction="row" spacing={3} sx={{ mt: 2 }}>
                      <ImportSelectionPanel
                        t={t}
                        activeTab={selectedTab}
                        onTabChange={handleChangeTab}
                        importableColumns={dataColumns}
                        importableRows={dataRows}
                        existingColumns={dataColumns2}
                        existingRows={dataRows2}
                        selectedRowIds={selectedRows}
                        onSelectionChange={handleSelectedRow}
                      />
                      <ImportAssociationPanel
                        t={t}
                        importType={selImportType}
                        professionistaValues={parsedArrProfList}
                        provinciaValues={parsedArrProvinceList}
                        comuneValues={parsedArrComuniList}
                        tipoIdentValues={parsedArrTipoIdentList}
                        tipoDocValues={parsedArrTipoDocList}
                        users={utentiList}
                        importMappings={mappedValuesList}
                        profPrestMappings={mappedProfPrestList}
                        prestazioneOptions={baseTipoPrestazioneList}
                        provinceOptions={baseProvinceList}
                        comuniOptions={baseComuniList}
                        tipoIdentOptions={baseTipoIdentList}
                        tipoDocOptions={baseTipoDocList}
                        onMappingChange={handleChange}
                        onImportDateChange={(val) => setUseImportDate(val)}
                      />
                    </Stack>
                  </Fragment>
                ) : null}
              </Fragment>
            ) : (
              <ImportFinishedPanel
                t={t}
                importedCount={importFinishedCountOk}
                importErrors={importFinishedErrors}
                onNewImport={handleNewImportClick}
              />
            )}
          </VaporPage.Section>
        ) : null}
      </VaporPage>

      <VaporToolbar
        variant="regular"
        size="medium"
        withoutAppBar={false}
        contentRight={
          <ImportToolbarActions
            t={t}
            selectedCount={selectedRows.length}
            onCancel={handleCancelClick}
            onConfirmImport={handleConfirmImportClick}
          />
        }
      ></VaporToolbar>
    </Fragment>
  );
  //#endregion
}

